/* eslint-disable no-new */
import EventClass from "common/utils/ui/event-class";

export class Redesign2025SubMasthead extends EventClass {
  event(event, $target) {
    super.event(event, $target);
    const { subCategory, subMenu, hasItems } = $target.dataset;

    // Handle menu item highlighting
    document.querySelectorAll(`[data-sub-menu="${subMenu}"]`).forEach($item => {
      const { baseClass, activeClass, subCategory: itemSubCategory } = $item.dataset;
      if (subCategory === itemSubCategory) $item.setAttribute("class", activeClass);
      else $item.setAttribute("class", baseClass);
    });

    // Handle content visibility and container padding based on hasItems
    if (subMenu === "Blanks") {
      const $navContainer = document.querySelector(".js-blanks-nav-content");

      if ($navContainer) {
        // Show content area only if the category has items
        if (hasItems === "true") {
          $navContainer.classList.add("gap-6", "pr-6");
        } else {
          $navContainer.classList.remove("gap-6", "pr-6");
        }
      }
    }
  }
}

export default () =>
  new Redesign2025SubMasthead({ eventSelector: ".js-redesign-2025-sub-menu", event: "mouseover" });
